import type { MFNamesKeys } from '@packages/config/MFNames';
import { CacheNames } from '@packages/service-worker/src/types';

export async function checkNewVersionApp() {
	let needToReload = false;
	if (process.env.NODE_ENV === 'production') {
		const appVersions = await getAppVersionsFile();
		const appVersionsHash = window.btoa(JSON.stringify(appVersions));
		const oldAppVersionsHash: string =
			localStorage.getItem('appVersions') || '';
		const oldAppVersions = oldAppVersionsHash
			? JSON.parse(window.atob(oldAppVersionsHash))
			: null;
		const mfsToClearCache: MFNamesKeys[] = [];

		if (
			appVersions &&
			oldAppVersions &&
			appVersionsHash !== oldAppVersionsHash
		) {
			const oldAppVersionsKeys = Object.keys(
				oldAppVersions,
			) as MFNamesKeys[];
			for (const oldAppVersionsKey of oldAppVersionsKeys) {
				if (
					appVersions[oldAppVersionsKey] !==
					oldAppVersions[oldAppVersionsKey]
				) {
					mfsToClearCache.push(oldAppVersionsKey);
				}
			}
		}
		localStorage.setItem('appVersions', appVersionsHash);

		if (mfsToClearCache.length) {
			await clearCaches(mfsToClearCache);
			needToReload = true;
		}
		document.documentElement.setAttribute(
			'data-is-checking-new-version',
			'false',
		);
	} else {
		document.documentElement.setAttribute(
			'data-is-checking-new-version',
			'false',
		);
	}

	if (
		(process.env.NODE_ENV === 'development' ||
			process.env.stand === 'test') &&
		needToReload
	) {
		console.info('=========================================');
		console.info('clearCaches');
		console.info('=========================================');
	}
	return needToReload;
}
async function clearCaches(mfsToClearCache: MFNamesKeys[]): Promise<void> {
	const cacheNames = Object.values(CacheNames).filter(
		(cacheName) =>
			cacheName !== CacheNames.wasm && cacheName !== CacheNames.fonts,
	);
	const mfsHostToClear = mfsToClearCache.map((mfName) =>
		window.getMfLink(mfName),
	);
	await Promise.all(
		cacheNames.map((cacheName) =>
			caches.open(cacheName).then(async (cacheStorage) => {
				const requests = await cacheStorage.keys();
				await Promise.all(
					requests.map(async (request) => {
						if (
							mfsHostToClear.find((mfsHostToClearRegexp) =>
								request.url.includes(mfsHostToClearRegexp),
							)
						) {
							const response = await cacheStorage.match(request);
							if (response) {
								await cacheStorage.delete(request);
							}
						}
					}),
				);
			}),
		),
	);
}
async function getAppVersionsFile(): Promise<Record<
	MFNamesKeys,
	string
> | null> {
	let currentMfVersions: Record<string, string> | null = null;
	try {
		const appVersionResponse = await fetch(
			window.getAppEnv('appVersionsUrl'),
		);
		currentMfVersions = await appVersionResponse.json();
	} catch (_e) {}

	return currentMfVersions;
}
